export type { FetchLatencyMonitor, FetchLatencyMonitorOptions } from './fetchLatency.ts'
export {
  createFetchLatencyMonitor,
  FETCH_LATENCY_FAST_THRESHOLD_MS,
  FETCH_LATENCY_MIN_SAMPLES,
  FETCH_LATENCY_SLOW_THRESHOLD_MS,
  FETCH_LATENCY_WINDOW_SIZE,
} from './fetchLatency.ts'
